import _ from 'lodash';
import uuidv4 from 'uuid/v4';
import store from '@store';
import { setErrorPopUp, setNotification } from '@reducers/notification';
import { APP_CONFIG } from '@constants';
import {
  setSeat,
  addToCart,
  addChecks,
  editCartItem,
  setSelectedModifierPath,
  toggleNestedModifierFlag,
  appendModifiersToList,
  pushModifiersGroupData,
  pushModifierToItem,
  setIsSubNestModifier,
  setSelectedModGroup,
  setNestedModifierArray,
  setTempModifier,
  getSyncModifierData,
  setSelectedModifiers,
  setAddModifierBool,
  removeModifiers,
  removeItemFromCart,
  setFunctionModifierId,
  setCartUpdateLoading,
  setCartSyncDone,
  pushModifierToCount,
  setPosition
} from '@reducers/orders';
import { safeJsonParse } from '@utility/helperFunction';
import { flowType } from '@utility/userInfo';
import { handleModifierInGlobalModClick } from './GlobalModifier/GlobalModifierActionHandler';
import { updateChecksAfterResponse, deleteItm } from '@reducers/storeChecks';
import { ERROR_MESSAGE } from '@constants';
import filter from 'lodash/filter';
import groupBy from 'lodash/groupBy';
import {
  mapStringCartToObject,
  getObjectValue,
  urlSearchParams,
  renderExcludeModifier,
} from '@utility/utills';
import userInfo from '../../utility/userInfo';

export const getPath = (data, dataToAppend) => {
  const arrayData = Array.isArray(data) ? [...data] : data ? [data] : [];
  if (dataToAppend) {
    arrayData.push(dataToAppend);
  }
  return arrayData.join('|');
};

//TODO: Cart Quantity set to 1 temporarily.
//Add the logic later
export const handleOnAddCart = (params, navigate, cartQuantity = 1, note = '') => {
  const { orders } = store.getState();
  const { modifierData, menuItemsHashTable, modifierGroupsHashTable } = orders;

  const sortedModifierData = _.sortBy(modifierData, o => {
    return getObjectValue(
      () =>
        _.find(
          menuItemsHashTable[Number(params.menuItemId)].modifierGroupLinks,
          d => d.modifierGroupId === Number(o.split('|')[0].split('-')[1])
        ).sortOrder,
      200
    );
  });
  const requiredModifierList = [];
  const activeMenuItemId =
    Number(urlSearchParams('menuId')) ||
    (orders.menusList[orders.menuIndex] &&
      orders.menusList[orders.menuIndex].id) ||
    0;
  menuItemsHashTable[params.menuItemId].modifierGroupLinks.forEach(item => {
    const modifierGroup = modifierGroupsHashTable[item.modifierGroupId];
    if (
      modifierGroup?.minimum > 0 &&
      modifierGroup.hiddenMenuId !== activeMenuItemId
    ) {
      requiredModifierList.push({
        ...item,
        modifierGroupId: item.modifierGroupId,
        name: modifierGroup.name,
        minimum: modifierGroup.minimum,
        maximum: modifierGroup.maximum,
        supportsModifierGroupWeights: modifierGroup.isWeight || false,
      });
    }
  });
  const modifierListGroupById = _.groupBy(
    sortedModifierData.filter(e => e),
    d => !d.includes('|') && d.split('|')[0].split('-')[1]
  );
  // const modifierDivs = document.querySelectorAll('[modifier-group]');
  for (const requiredModifier of requiredModifierList) {
    const modifierList =
      modifierListGroupById[requiredModifier.modifierGroupId];
    const weight = getModifierWeight(
      modifierList,
      requiredModifier.supportsModifierGroupWeights
    );
    if (
      weight < requiredModifier.minimum ||
      (requiredModifier.maximum > 0 && weight > requiredModifier.maximum)
    ) {
      const modifierDivs = document.querySelectorAll('[modifier-group]');
      modifierDivs.forEach(
        modifier =>
          Number(modifier.id) === Number(requiredModifier.modifierGroupId) &&
          modifier.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          })
      );
      store.dispatch(
        setErrorPopUp({
          res: `${weight < requiredModifier.minimum
            ? ERROR_MESSAGE.SELECT_REQUIRED_MODIFIERS
            : ERROR_MESSAGE.SELECT_EXCEEDS_MODIFIERS
            }: ${requiredModifier.name}`,
          noErrorTxt: true,
        })
      );
      return;
    }
  }
  handleonAddToCart(cartQuantity, params, navigate, note, sortedModifierData);
  navigate(`${APP_CONFIG.BASE_URL}/orders`);
};

const getModifierWeight = (
  segmentedModifierIdList,
  supportsModifierGroupWeights
) => {
  let weight = 0;
  const { orders } = store.getState();
  const { modifiersHashTable, modifierGroupsHashTable } = orders;
  const isKiosk = flowType() === 'kiosk';
  if (!supportsModifierGroupWeights || isKiosk) {
    (segmentedModifierIdList || []).forEach(segmentedModifierId => {
      const modifierId = segmentedModifierId.split('-')[0]; // format: "{modifierId}-{modifierGroupId}" e.g. "229876-79083"
      const modifier = modifiersHashTable[modifierId];
      if (segmentedModifierId.includes('|')) {
        weight = modifier.weight || 1;
      } else {
        weight += modifier.weight || 1;
      }
    });
  } else {
    (segmentedModifierIdList || []).forEach(segmentedModifierId => {
      const modifierId = segmentedModifierId.split('-')[0];
      const modifierGroupId = segmentedModifierId.split('-')[1];
      const modifierGroup = modifierGroupsHashTable[modifierGroupId];
      const modifierGroupLinks = modifierGroup.modifierLinks;
      const modifierGroupLink = modifierGroupLinks.find(
        x => x.modifierId === Number(modifierId)
      );
      if (modifierGroupLink) {
        if (segmentedModifierId.includes('|')) {
          weight = modifierGroupLink.weight;
        } else {
          weight += modifierGroupLink.weight;
        }
      }
    });
  }
  return weight;
};

const handleonAddToCart = (quantity, params, navigate, note = '', preSortedModifierData = null) => {
  store.dispatch(setCartUpdateLoading(true));
  const { orders } = store.getState();
  const {
    modifierData,
    menuItemsHashTable,
    modifierGroupsHashTable,
    cart,
    menuCard,
  } = orders;
  const { menuTypeId, menuItemId, internalId } = params;
  let sortedModifierData = preSortedModifierData || _.sortBy(modifierData, o => {
    return getObjectValue(
      () =>
        _.find(
          menuItemsHashTable[Number(menuItemId)].modifierGroupLinks,
          d => d.modifierGroupId === Number(o.split('|')[0].split('-')[1])
        ).sortOrder,
      200
    );
  });
  const linkedMenuItems = sortedModifierData.filter(
    d =>
      d &&
      modifierGroupsHashTable[Number(d.split('|')[0].split('-')[1])]?.linked &&
      !d.split('|')[1]
  );
  if (linkedMenuItems.length > 0) {
    sortedModifierData = sortedModifierData.filter(
      d =>
        d &&
        !modifierGroupsHashTable[Number(d.split('|')[0].split('-')[1])]?.linked
    );
  }
  const parentMenuItemIndex = (cart || []).findIndex(
    c => c.internalId === Number(params.internalId)
  );
  let uniqueIdForLinkedItem = getLinkedUniqueId(
    linkedMenuItems,
    parentMenuItemIndex,
    params
  );
  const isPack =
    menuItemsHashTable?.[Number(params.menuItemId)]?.pack ||
    menuItemsHashTable?.[Number(params.menuItemId)]?.cardType === 1;
  if (isPack && !params.internalId && linkedMenuItems.length > 0 && quantity > 1) {
    uniqueIdForLinkedItem = Array.from({ length: quantity }, () => uuidv4());
  }
  const uniqueIdForGameCardItem = getUniqueIdforGameCard(linkedMenuItems);
  const parentContainsLinkedItem = linkedMenuItems.length > 0;
  const itemInfo = menuCard[menuTypeId][menuItemId];
  const dataToSend = {
    quantity,
    price: itemInfo.price,
    menuItemId: itemInfo.menuItemId,
    menuTypeId: itemInfo.menuTypeId,
    modifiers: sortedModifierData,
    menuItemName: (itemInfo?.menuItem || {})?.name,
    favorite: itemInfo.menuItem.favorite,
    modifierData: sortedModifierData,
    hasLinkedMenuItem: linkedMenuItems.length > 0,
    // 1. parent item
    uniqueIdForLinkedItem,
    uniqueIdForGameCardItem,
    serverAppModifierGroupDisplayStyle:
      itemInfo.serverAppModifierGroupDisplayStyle,
  };
  const parentMenuItem = cart[parentMenuItemIndex];
  const removedItems = (parentMenuItem?.modifierData || [])?.filter(
    e => !(modifierData || []).includes(e)
  );
  const seat = safeJsonParse(window.sessionStorage.getItem('seat'), {});
  // const position =
  //   seat?.seats.filter(e => e.open).length > 0
  //     ? seat.seats.find(e => e.open)
  //     : { number: -1, position: -1 };
  // store.dispatch(setPosition(position)); 
  if (linkedMenuItems.length > 0 || removedItems.length > 0) {
    if (internalId) {
      const itemsToDelete = [];
      cart.forEach(c => {
        if (
          removedItems?.some(e =>
            e
              .split('|')[0]
              .split('-')[0]
              .includes(c.menuItemId)
          )
        ) {
          itemsToDelete.push(c);
        }
      });
      const itemsToAdd = [];
      linkedMenuItems.forEach(c => {
        const addIndex = cart.findIndex(e =>
          c
            .split('|')[0]
            .split('-')[0]
            .includes(e.menuItemId)
        );
        if (addIndex === -1) {
          itemsToAdd.push(c);
        }
      });
      if (itemsToDelete.length > 0) {
        menuAddToCart({
          data: dataToSend,
          isLinkedItemAdd: false,
          isLinkedEdit: false,
          parentContainsLinkedItem,
          linkedItems: null,
          step: 0,
          cart: quantity,
          uniqueIdForLinkedItem,
          uniqueIdForGameCardItem,
          params,
          navigate,
          note,
        });
        deleteItem(itemsToDelete, params);
      }
      if (itemsToAdd.length > 0) {
        menuAddToCart({
          data: dataToSend,
          isLinkedItemAdd: false,
          isLinkedEdit: false,
          parentContainsLinkedItem,
          linkedItems: null,
          step: 0,
          cart: quantity,
          uniqueIdForLinkedItem,
          uniqueIdForGameCardItem,
          params,
          navigate,
          note,
        });
        // Add new linked child items (menuAddToCart recurses through all steps internally)
        menuAddToCart({
          data: dataToSend,
          isLinkedItemAdd: true,
          isLinkedEdit: true,
          parentContainsLinkedItem,
          linkedItems: itemsToAdd,
          step: 0,
          cart: quantity,
          uniqueIdForLinkedItem: cart[parentMenuItemIndex].uniqueIdForLinkedItem,
          uniqueIdForGameCardItem,
          params,
          navigate,
          note,
        });
        // store.dispatch(setCartUpdateLoading(false));
      }
      if (itemsToDelete.length === 0 && itemsToAdd.length === 0) {
        menuAddToCart({
          data: dataToSend,
          isLinkedItemAdd: false,
          isLinkedEdit: false,
          parentContainsLinkedItem,
          linkedItems: null,
          step: 0,
          cart: quantity,
          uniqueIdForLinkedItem,
          uniqueIdForGameCardItem,
          params,
          navigate,
          note,
        });
        // store.dispatch(setCartUpdateLoading(false));
      }
    } else {
      menuAddToCart({
        data: dataToSend,
        isLinkedItemAdd: false,
        isLinkedEdit: false,
        parentContainsLinkedItem,
        linkedItems: null,
        step: 0,
        cart: quantity,
        uniqueIdForLinkedItem,
        uniqueIdForGameCardItem,
        params,
        navigate: () => {},
        note,
      });
      menuAddToCart({
        data: dataToSend,
        isLinkedItemAdd: true,
        isLinkedEdit: false,
        parentContainsLinkedItem: false,
        linkedItems: linkedMenuItems,
        step: 0,
        cart: quantity,
        uniqueIdForLinkedItem,
        uniqueIdForGameCardItem,
        params,
        navigate,
        note,
      });
      // store.dispatch(setCartUpdateLoading(false));
    }
  } else {
    menuAddToCart({
      data: dataToSend,
      isLinkedItemAdd: false,
      isLinkedEdit: false,
      parentContainsLinkedItem,
      linkedItems: null,
      step: 0,
      cart: quantity,
      uniqueIdForLinkedItem,
      uniqueIdForGameCardItem,
      params,
      navigate,
      note,
    });
  }
};

const getLinkedUniqueId = (linkedMenuItems, parentMenuItemIndex, params) => {
  let uniqueId = null;
  const { orders } = store.getState();
  const { cart } = orders;
  const { internalId } = params;
  if (linkedMenuItems.length > 0 && internalId) {
    uniqueId = cart[parentMenuItemIndex].uniqueIdForLinkedItem;
  } else if (linkedMenuItems.length > 0 && !params.internalId) {
    uniqueId = uuidv4();
  }
  return uniqueId;
};

const getUniqueIdforGameCard = (linkedMenuItems) => {
  let uniqueId = uuidv4();
  return uniqueId;
}


const applyPendingModifierNotes = modifierObject => {
  const pendingNotes = safeJsonParse(
    window.sessionStorage.getItem('pendingModifierNote'),
    {}
  );
  if (!pendingNotes || Object.keys(pendingNotes).length === 0) {
    return modifierObject;
  }
  return (modifierObject || []).map(mod => {
    const noteEntry = pendingNotes[`${mod.modifierId}_${mod.modifierGroupId}`];
    return noteEntry?.note ? { ...mod, note: noteEntry.note } : mod;
  });
};

const menuAddToCart = ({
  data,
  isLinkedItemAdd,
  isLinkedEdit,
  parentContainsLinkedItem,
  linkedItems,
  step,
  cart,
  uniqueIdForLinkedItem,
  uniqueIdForGameCardItem,
  params,
  navigate,
  note = '',
}) => {
  let dataToSend = data;

  const { orders, oauth } = store.getState();
  const { deviceInformation, authInfo, loggedInUserData } = oauth;
  const query = new URLSearchParams(window.location.search);
  const type = query.get('type');
  const {
    modifierData,
    menuItemsHashTable,
    modifierGroupsHashTable,
    modifiersHashTable,
    menuCard,
    menusList,
    menuIndex,
    menusHashTable,
    position,
    seats,
    coursesHashTable,
    selectedModifiers,
  } = orders;
  const { menuTypeId, menuItemId, internalId } = params;
  const itemInfo = menuCard[menuTypeId][menuItemId];
  if (linkedItems) {
    const linkedMenuItemInfo =
      menuItemsHashTable[Number(linkedItems[step].split('|')[0].split('-')[0])];
    const linkedMenuItemModifierData = modifierData
      .filter(e => e)
      .reduce((a, v) => {
        const parentMod = Number(v.split('|')[0].split('-')[0]);
        if (linkedMenuItemInfo.id === parentMod && v.split('|')[1]) {
          a.push(v.split('|')[1]);
        }
        return a;
      }, []);
    const linkedMenuAddData = {
      quantity: cart,
      price: linkedMenuItemInfo.price || null,
      menuItemId: linkedMenuItemInfo.id,
      menuTypeId: itemInfo.menuTypeId || null,
      modifiers: linkedMenuItemModifierData,
      menuItemName: linkedMenuItemInfo.name,
      favorite: linkedMenuItemInfo.favorite,
      modifierData: linkedMenuItemModifierData,
      isLinked: true,
      uniqueIdForLinkedItem,
      uniqueIdForGameCardItem,
    };
    dataToSend = linkedMenuAddData;
  }
  const comboItems = [];
  let cartItem = updateExcludeModifier([dataToSend]);
  cartItem = applyModFunction(cartItem);
  const modifierObject = getObjectValue(
    () =>
      mapStringCartToObject(
        cartItem,
        [],
        modifiersHashTable,
        modifierGroupsHashTable
      )[0].modifiers,
    []
  );
  const filteredModifiers = modifierObject?.filter((modifier, index, self) => {
    const hasModifiers = modifier?.modifiers && modifier?.modifiers.length > 0;
    const isUniqueModifierName =
      self.findIndex(item => item.modifierName === modifier?.modifierName) ===
      index;

    return hasModifiers || isUniqueModifierName;
  });
  if (
    filteredModifiers.length > 0 &&
    filteredModifiers.filter(e =>
      menusList[menuIndex]?.globalModifierGroupIds?.includes(e.modifierGroupId)
    ).length > 0
  ) {
    arraymove(
      filteredModifiers,
      filteredModifiers.filter(
        e =>
          !menusList[menuIndex]?.globalModifierGroupIds?.includes(
            e.modifierGroupId
          )
      ),
      modifierObject.length - 1
    );
  }

  dataToSend.modifierObject = applyPendingModifierNotes(modifierObject);
  if (linkedItems) {
    const linkedMenuItemInfo =
      menuItemsHashTable[Number(linkedItems[step].split('|')[0].split('-')[0])];
    const selectedModifiersArr = selectedModifiers?.modifiers || [];
    for (const [index1, element] of selectedModifiersArr.entries()) {
      if (
        element.modifierId === linkedMenuItemInfo.id &&
        element.modifiers.length > 0
      ) {
        for (const mod of element.modifiers) {
          if (mod.modifiers.length > 0) {
            for (const [index2, subElement] of mod.modifiers.entries()) {
              subElement.index = index2;
              dataToSend.modifierObject[index1].modifiers.push(subElement);
            }
          }
        }
      }
    }
  }
  let modifierCopy;
  if (!isLinkedItemAdd && parentContainsLinkedItem) {
    const sortedModifierDataWithLinkedItems = _.sortBy(modifierData, o => {
      return getObjectValue(
        () =>
          _.find(
            menuItemsHashTable[Number(params.menuItemId)].modifierGroupLinks,
            d => d.modifierGroupId === Number(o.split('|')[0].split('-')[1])
          ).sortOrder,
        200
      );
    });
    const dataToSendCopy = { ...data };
    dataToSendCopy.modifiers = sortedModifierDataWithLinkedItems;
    let cartItemCopy = updateExcludeModifier([dataToSendCopy]);
    cartItemCopy = applyModFunction(cartItemCopy);
    const modifierObjectCopy = getObjectValue(
      () =>
        mapStringCartToObject(
          cartItemCopy,
          [],
          modifiersHashTable,
          modifierGroupsHashTable
        )[0].modifiers,
      []
    );
    modifierCopy = applyNoteFunction(
      modifierObjectCopy.filter(e => e.modifierGroupId)
    );
  }
  if (!params.internalId || isLinkedEdit) {
    const modiferPrice = calculateModifierAmount(modifierData, params);
    const updatedModifierObject = applyNoteFunction(
      (dataToSend.modifierObject || []).filter(e => e.modifierGroupId)
    );
    const requestData = {
      ...dataToSend,
      note,
      pending: true,
      seatIds: position.number === -1 ? [] : [position.seatId],
      price: Number(dataToSend.price) + modiferPrice,
      menuScreenId: Number(params.menuTypeId),
      ageRestricted: menusHashTable[Number(params.menuTypeId)].ageRestricted,
      internalId: new Date().getTime(),
      menuId: menusList[menuIndex].id,
      storeId: deviceInformation.storeId,
      modifiers: updatedModifierObject.length > 0 ? updatedModifierObject : (dataToSend.modifierObject || []),
      modifierData: modifierData,
      refill: urlSearchParams('refill') === 'true' ? true : false,
    };
    if (!isLinkedItemAdd) {
      const rawHoldTime = window.sessionStorage.getItem('pendingHoldTime');
      if (rawHoldTime !== null) {
        requestData.holdTime = safeJsonParse(rawHoldTime, '');
      }
    }
    const filteredModifierCopy = (modifierCopy || []).filter(
      e => !e.isLinkedItem
    );
    const fallbackModifiers =
      updatedModifierObject.length > 0
        ? updatedModifierObject
        : dataToSend.modifierObject || [];
    const finalParentModifiers =
      !isLinkedItemAdd && parentContainsLinkedItem && filteredModifierCopy.length > 0
        ? filteredModifierCopy
        : fallbackModifiers;
    const finalJsonModifiers =
      !isLinkedItemAdd && parentContainsLinkedItem && modifierCopy && modifierCopy.length > 0
        ? modifierCopy
        : fallbackModifiers;
    const modifierJsonData = {
      ...requestData,
      modifiers: finalJsonModifiers,
    };
    if (!isLinkedItemAdd && parentContainsLinkedItem) {
      requestData.modifiers = finalParentModifiers;
    }
    requestData.modifierJson = JSON.stringify(modifierJsonData);
    // eslint-disable-next-line
    const dataToSendToAdd = {
      storeId: deviceInformation.storeId,
      employeeId: Number(loggedInUserData?.id) || Number(authInfo?.employeeId) || Number(authInfo?.id),
      deviceId: deviceInformation.deviceId,
      checkHeaderId: seats?.id,
      employeeCard: loggedInUserData?.employeeCard,
      items: [requestData],
      orderJson: JSON.stringify(requestData),
      longitude: '0',
      latitude: '0',
      geoLocation: '0',
    };
    // Main item with a positive hold time: call the add API directly so the
    // server registers the hold before navigation (optimistic path skips the API).
    if (!isLinkedItemAdd && requestData.holdTime > 0) {
      store
        .dispatch(addChecks(dataToSendToAdd, 'add', false))
        .then(res => {
          store.dispatch(setSeat({ ...res }));
          store.dispatch(updateChecksAfterResponse(res));
          const responseObj = getObjectValue(() => res.orders[0], []).items[
            res.orders[0].items.length - 1
          ];
          const finalCartData = {
            ...requestData,
            id: responseObj?.id,
            checkItemId: responseObj?.checkItemId,
          };
          store.dispatch(addToCart(finalCartData)).then(() => {
            navigate(`${APP_CONFIG.BASE_URL}/orders`);
            store.dispatch(setCartUpdateLoading(false));
          });
        })
        .catch(e => {
          store.dispatch(setErrorPopUp({ res: e.message }));
          store.dispatch(setCartUpdateLoading(false));
        });
      return;
    }
    comboItems.push(requestData);
    const proccessingId = uuidv4();
    const destructuredObj = {
      ageRestricted: false,
      checkItemId: '',
      id: '',
      orderJson: JSON.stringify(requestData),
      orderedAt: '',
      pending: true,
      proccessingId,
      isProcessing: true,
    };
    const cartData = {
      ...requestData,
      isProcessing: true,
    };
    const checkHeaderObj = seats;
    if (checkHeaderObj.orders[0]) {
      checkHeaderObj.orders[0].items.push(destructuredObj);
    }
    store.dispatch(updateChecksAfterResponse({ ...checkHeaderObj }));
    store.dispatch(setSeat({ ...checkHeaderObj }));
    store.dispatch(addToCart(cartData));
    const device =
      JSON.parse(window.sessionStorage.getItem('deviceInfo')) ?? [];
    if (linkedItems && step !== linkedItems.length - 1) {
      menuAddToCart({
        data: [],
        isLinkedItemAdd: true,
        isLinkedEdit,
        parentContainsLinkedItem: false,
        linkedItems,
        step: step + 1,
        cart,
        uniqueIdForLinkedItem,
        uniqueIdForGameCardItem,
        params,
        navigate,
      });
    } else {
      if (
        device?.deviceGroup?.serverAppSettings?.enforcePivotSeating &&
        type !== 'edit'
      ) {
        const menudata = getObjectValue(
          () => menuItemsHashTable[data.menuItemId]
        );
        if (
          position?.number !== -1 &&
          getObjectValue(() => coursesHashTable[menudata.brandCourseId])
            ?.pivotSeating
        ) {
          const seats = getObjectValue(
            () => JSON.parse(window.sessionStorage.getItem('seat')),
            []
          );
          const availableSeats = seats?.seats?.filter(item => {
            return item.open === true;
          });
          const value = availableSeats?.findIndex(object => {
            return object.id === position?.id;
          });
          if (value < availableSeats?.length - 1) {
            store.dispatch(setPosition(availableSeats[value + 1]));
          } else {
            store.dispatch(setPosition(availableSeats[0]));
          }
          navigate(`${APP_CONFIG.BASE_URL}/orders`);
        }
      }
      navigate(`${APP_CONFIG.BASE_URL}/orders`);
      store.dispatch(setCartSyncDone(true));
    }
  } else if (internalId && type?.includes('repeat')) {
    const modiferPrice = calculateModifierAmount(modifierData, params);
    const requestData = {
      ...dataToSend,
      note,
      pending: true,
      seatIds: position.number === -1 ? [] : [position.seatId],
      price: Number(dataToSend.price) + modiferPrice,
      menuScreenId: Number(menuTypeId),
      ageRestricted: menusHashTable[Number(menuTypeId)].ageRestricted,
      internalId: new Date().getTime(),
      menuId: menusList[menuIndex].id,
      storeId: deviceInformation.storeId,
      modifiers: dataToSend.modifierObject,
      modifierData: modifierData,
      refill: urlSearchParams('refill') === 'true' ? true : false,
    };
    requestData.modifierJson = JSON.stringify(requestData);
    const dataToSendToAdd = {
      storeId: deviceInformation.storeId,
      employeeId: Number(loggedInUserData?.id) || Number(authInfo?.employeeId) || Number(authInfo?.id),
      deviceId: deviceInformation.deviceId,
      checkHeaderId: seats?.id,
      employeeCard: loggedInUserData?.employeeCard,
      items: [requestData],
      orderJson: JSON.stringify(requestData),
      longitude: '0',
      latitude: '0',
      geoLocation: '0',
    };
    store
      .dispatch(addChecks(dataToSendToAdd, 'add', false))
      .then(res => {
        store.dispatch(setSeat({ ...res }));
        store.dispatch(updateChecksAfterResponse(res));
        const responseObj = getObjectValue(() => res.orders[0], []).items[
          res.orders[0].items.length - 1
        ];
        requestData.modifiers =
          !isLinkedItemAdd && parentContainsLinkedItem
            ? modifierCopy
            : requestData.modifiers;
        const cartData = {
          ...requestData,
          id: responseObj.id,
          checkItemId: responseObj.checkItemId,
        };
        store.dispatch(addToCart(cartData)).then(() => {
          navigate(`${APP_CONFIG.BASE_URL}/orders`);
          store.dispatch(setCartUpdateLoading(false));
        });
      })
      .catch(e => {
        store.dispatch(
          setErrorPopUp({
            res: e.message,
          })
        );
        store.dispatch(setCartUpdateLoading(false));
      });
  } else {
    const editCheckItemId = Number(urlSearchParams('checkItem'));
    const modiferPrice = calculateModifierAmount(modifierData, params);
    let seatId = 0;
    if (position.number === -1 || !position.seatId) {
      seatId = [];
    } else {
      seatId = [position.seatId];
    }
    const requestObj = {
      ...dataToSend,
      note,
      pending: true,
      seatIds: Number(urlSearchParams('seatId'))
        ? [Number(urlSearchParams('seatId'))]
        : seatId,
      price: Number(dataToSend.price) + modiferPrice,
      internalId: !Number(internalId)
        ? new Date().getTime()
        : Number(internalId),
      menuScreenId: Number(menuTypeId),
      ageRestricted: menusHashTable[Number(menuTypeId)].ageRestricted,
      menuId: menusList[menuIndex].id,
      storeId: deviceInformation.storeId,
      modifiers: dataToSend.modifierObject,
      modifierData: modifierData,
      refill: urlSearchParams('refill') === 'true' ? true : false,
    };
    if (!isLinkedItemAdd) {
      const rawHoldTime = window.sessionStorage.getItem('pendingHoldTime');
      if (rawHoldTime !== null) {
        requestObj.holdTime = safeJsonParse(rawHoldTime, '');
      }
    }
    const updatedModifierObject = (
      (dataToSend.modifierObject || []).filter(e => e.modifierGroupId)
    );
    const filteredModifierCopy = (modifierCopy || []).filter(
      e => !e.isLinkedItem
    );
    const fallbackModifiers =
      updatedModifierObject.length > 0
        ? updatedModifierObject
        : dataToSend.modifierObject || [];
    const finalParentModifiers =
      !isLinkedItemAdd && parentContainsLinkedItem && filteredModifierCopy.length > 0
        ? filteredModifierCopy
        : fallbackModifiers;
    const finalJsonModifiers =
      !isLinkedItemAdd && parentContainsLinkedItem && modifierCopy && modifierCopy.length > 0
        ? modifierCopy
        : fallbackModifiers;
    const modifierJsonData = {
      ...requestObj,
      modifiers: finalJsonModifiers,
    };
    requestObj.modifierJson = JSON.stringify(modifierJsonData);
    const itemInfoObj = {
      ...requestObj,
      seatIds:
        position.number === -1 || !position.seatId ? [] : [position.seatId],
      modifiers:
        !isLinkedItemAdd && parentContainsLinkedItem
          ? finalParentModifiers
          : fallbackModifiers,
      suppressNote: false,
      openPrice: null,
      ageRestricted: false,
      checkOrderItemId: Number(urlSearchParams('checkItem')),
    };

    const isServerApp = flowType() === 'serverApp';
    const isCounter =
      isServerApp && [1].includes(deviceInformation.deviceGroup.startMode);
    const isDriveThru =
      isServerApp && [3].includes(deviceInformation.deviceGroup.startMode);
    const dataToSendToAdd = {
      storeId: deviceInformation.storeId,
      employeeId: Number(loggedInUserData?.id) || Number(authInfo?.employeeId) || Number(authInfo?.id),
      deviceId: deviceInformation.deviceId,
      checkHeaderId: seats?.id,
      employeeCard: loggedInUserData?.employeeCard,
      items: [itemInfoObj],
      orderJson: JSON.stringify(itemInfoObj),
      longitude: '0',
      latitude: '0',
      geoLocation: '0',
    };
    store
      .dispatch(addChecks(dataToSendToAdd, 'update', false))
      .then(res => {
        store.dispatch(setSeat({ ...res }));
        store.dispatch(updateChecksAfterResponse(res));
        const responseObj = getObjectValue(() => res.orders[0], []).items.find(
          si => si.id === editCheckItemId
        );
        requestObj.modifiers =
          !isLinkedItemAdd && parentContainsLinkedItem
            ? modifierCopy
            : requestObj.modifiers;
        let modifierPrice = JSON.parse(responseObj.orderJson).price;
        if (requestObj.pending && requestObj.itemType !== 'D') {
          let mPrice = i => {
            modifierPrice += i.price * i.quantity;
            if (i.modifiers.length > 0) {
              i.modifiers?.forEach(i => mPrice(i));
            }
            return;
          };
          JSON.parse(responseObj.orderJson).modifiers?.forEach(i => mPrice(i));
        }
        requestObj.price =
          isCounter || isDriveThru ? modifierPrice : requestObj.price;
        const cartData = {
          ...requestObj,
          note,
          id: responseObj.id,
          checkItemId: responseObj.checkItemId,
        };
        store.dispatch(editCartItem(cartData)).then(() => {
          navigate(`${APP_CONFIG.BASE_URL}/orders`);
          store.dispatch(setCartUpdateLoading(false));
        });
      })
      .catch(e => {
        store.dispatch(
          setErrorPopUp({
            res: e.message,
          })
        );
        store.dispatch(setCartUpdateLoading(false));
      });
  }
};

const updateExcludeModifier = cartItemsList => {
  const cartTemp = _.cloneDeep(cartItemsList);
  const { orders } = store.getState();
  const {
    modifiersHashTable,
    menuItemsHashTable,
    modifierGroupsHashTable,
  } = orders;
  cartTemp.forEach(cartItem => {
    renderExcludeModifier(
      menuItemsHashTable[cartItem.menuItemId].modifierGroupLinks,
      cartItem,
      modifierGroupsHashTable,
      modifiersHashTable,
      ''
    );
    cartItem.modifiers
      .filter(d => d?.includes('|') && !d?.includes('-0'))
      .forEach(d => {
        renderExcludeModifier(
          modifiersHashTable[d?.split('|')[0].split('-')[0]].modifierGroupLinks,
          cartItem,
          modifierGroupsHashTable,
          modifiersHashTable,
          `${d.split('|')[0]}|`
        );
      });
  });
  return cartTemp;
};
const applyModFunction = cartItemsList => {
  const { orders } = store.getState();
  const { modifierGroupsHashTable } = orders;
  cartItemsList.forEach(cartItem => {
    cartItem.modifiers
      .filter(e => e)
      .forEach(modifier => {
        modifier.split('|').forEach((mod, i) => {
          if (
            mod.split('-')[1] &&
            (modifierGroupsHashTable[mod.split('-')[1]] || {})?.applyModFunction
          ) {
            if (
              i === 0 &&
              !cartItem.modifiers.includes(
                `${mod}|${modifierGroupsHashTable[mod.split('-')[1]]
                  .modFunctionModifierId
                }-${modifierGroupsHashTable[mod.split('-')[1]]
                  .modFunctionModifierGroupId
                }`
              )
            ) {
              cartItem.modifiers.push(
                `${mod}|${modifierGroupsHashTable[mod.split('-')[1]]
                  .modFunctionModifierId
                }-${modifierGroupsHashTable[mod.split('-')[1]]
                  .modFunctionModifierGroupId
                }`
              );
            } else if (
              !cartItem.modifiers.includes(
                `${modifier}|${modifierGroupsHashTable[mod.split('-')[1]]
                  .modFunctionModifierId
                }-${modifierGroupsHashTable[mod.split('-')[1]]
                  .modFunctionModifierGroupId
                }`
              )
            ) {
              cartItem.modifiers.push(
                `${modifier}|${modifierGroupsHashTable[mod.split('-')[1]]
                  .modFunctionModifierId
                }-${modifierGroupsHashTable[mod.split('-')[1]]
                  .modFunctionModifierGroupId
                }`
              );
            }
          }
        });
      });
  });
  return cartItemsList;
};
const deleteItem = (data, redirectToOrders) => {
  const { orders, oauth } = store.getState();
  const { deviceInformation, authInfo, loggedInUserData } = oauth;
  const { seats } = orders;

  (data || []).forEach(item => {
    if (item.internalId) {
      store.dispatch(removeItemFromCart(item.internalId));
    }
  });

  const itemsWithCheckId = (data || []).filter(
    e => e.id || e.checkItemId || e.checkOrderItemId
  );
  if (itemsWithCheckId.length > 0) {
    const datatosend = {
      storeId: deviceInformation.storeId,
      deviceId: deviceInformation.deviceId,
      employeeId: Number(loggedInUserData?.id) || Number(authInfo?.employeeId) || Number(authInfo?.id),
      employeeCard: loggedInUserData?.employeeCard,
      checkHeaderId: seats?.id,
      items: itemsWithCheckId.map(e => {
        return { checkOrderItemId: e.id || e.checkItemId || e.checkOrderItemId };
      }),
    };
    store
      .dispatch(deleteItm(datatosend))
      .then(res => {
        store.dispatch(setSeat({ ...res }));
        store.dispatch(updateChecksAfterResponse(res)).then(() => {
          // TODO: Verify the navigation logic.
          // if (redirectToOrders) {
          //   navigate(`${APP_CONFIG.BASE_URL}/orders`);
          // }
        });
      })
      .catch(e => {
        console.log(e);
      });
  }
};
const applyNoteFunction = modifierObject => {
  const modifiers = getObjectValue(
    () =>
      JSON.parse(
        _.find(
          seats?.orders[0]?.items,
          e => e.id === Number(urlSearchParams('checkItem'))
        )?.orderJson
      )?.modifiers,
    []
  );
  const modifiersHashTable = {};
  modifierObject.forEach((d, i) => {
    modifiersHashTable[d.modifierId + '_' + d.modifierGroupId] = {
      ...d,
      index: i,
    };
  });
  // TODO: Revisit later
  // const temp = { ...modifierNote };
  // modifiers.forEach(e => {
  //   if (modifiersHashTable[e.modifierId + '_' + e.modifierGroupId]) {
  //     modifiersHashTable[e.modifierId + '_' + e.modifierGroupId] = {
  //       ...modifiersHashTable[e.modifierId + '_' + e.modifierGroupId],
  //       note: e.note,
  //     };
  //     if (_.isEmpty(modifierNote)) {
  //       temp[e.modifierId] = {
  //         modifierId: e.modifierId,
  //         note: e.note,
  //         open: false,
  //         modifierGroupId: e.modifierGroupId,
  //       };
  //     }
  //   }
  //   if (_.isEmpty(modifierNote)) {
  //     setModifierNote(temp);
  //   }
  // });
  // if (modifierNote) {
  //   Object.values(modifierNote).forEach(e => {
  //     if (modifiersHashTable[e?.modifierId + '_' + e?.modifierGroupId]) {
  //       modifiersHashTable[e?.modifierId + '_' + e?.modifierGroupId].note =
  //         e?.note;
  //     }
  //   });
  // }
  for (const element of Object.values(modifiersHashTable)) {
    if (element.weightKey) {
      element.modifierId = element.weightModifierId;
      delete element.weightKey;
      delete element.weightModifierId;
    }
  }
  return getObjectValue(
    () => orderBy(Object.values(modifiersHashTable), ['index'], ['asc']),
    []
  );
};
const calculateModifierAmount = (modifierData, params) => {
  let modiferPrice = 0;
  const modifierObject = mapStringCartToObject(
    [{ modifiers: modifierData }],
    []
  );
  const getModifierAmount = (modifierList, params) => {
    const isServerApp = flowType() === 'serverApp';
    const { orders, oauth } = store.getState();
    const { menuItemsHashTable, modifierGroupsHashTable, menuCard } = orders;
    const { menuTypeId, menuItemId, internalId } = params;
    modifierList.forEach(mod => {
      if (isServerApp) {
        const itemInfo = menuCard[menuTypeId][menuItemId];
        if (itemInfo.menuItem.combo) {
          if (
            !getObjectValue(
              () =>
                modifierGroupsHashTable[mod.modifierGroupId]?.includedInCombo
            )
          ) {
            modiferPrice +=
              mod.quantity *
              getObjectValue(
                () =>
                  Number(
                    _.find(
                      modifierGroupsHashTable[mod.modifierGroupId]
                        .modifierLinks,
                      d => d.modifierId === Number(mod.modifierId)
                    ).price
                  ),
                1
              );
          } else if (
            getObjectValue(
              () =>
                modifierGroupsHashTable[mod.modifierGroupId]?.includedInCombo
            ) &&
            getObjectValue(
              () =>
                menuItemsHashTable[mod.modifierId]?.comboUpSellAmount !== null
            )
          ) {
            modiferPrice +=
              mod.quantity *
              Number(
                getObjectValue(
                  () => menuItemsHashTable[mod.modifierId]?.comboUpSellAmount
                )
              );
          }
        } else {
          modiferPrice +=
            mod.quantity *
            getObjectValue(
              () =>
                Number(
                  _.find(
                    modifierGroupsHashTable[mod.modifierGroupId].modifierLinks,
                    d => d.modifierId === Number(mod.modifierId)
                  ).price
                ),
              1
            );
        }
      } else {
        modiferPrice +=
          mod.quantity *
          getObjectValue(
            () =>
              Number(
                _.find(
                  modifierGroupsHashTable[mod.modifierGroupId].modifierLinks,
                  d => d.modifierId === Number(mod.modifierId)
                ).price
              ),
            1
          );
      }
      if (mod.modifiers) {
        getModifierAmount(mod.modifiers, params);
      }
    });
  };
  getModifierAmount(modifierObject[0].modifiers, params);
  return modiferPrice;
};

const arraymove = (arr, nonGlobalArr, toIndex) => {
  nonGlobalArr.forEach(e => {
    const element = arr.find(g => g.modifierGroupId === e.modifierGroupId);
    const fromIndex = arr.findIndex(
      f => f.modifierGroupId === element.modifierGroupId
    );
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
  });
};

const onChangeModifier = (modifierData, params) => {
  const { orders, oauth } = store.getState();
  const {
    menuItemsHashTable,
    modifierGroupsHashTable,
    menuCard,
    modifiersHashTable,
    menusList,
    menuIndex,
    menusHashTable,
  } = orders;
  const { deviceInformation: deviceInfo } = oauth;
  const itemInfo = menuCard[params.menuTypeId][params.menuItemId];
  const sortedModifierData = _.sortBy(
    modifierData.filter(e => e),
    o => {
      return getObjectValue(
        () =>
          _.find(
            menuItemsHashTable[Number(params.menuItemId)].modifierGroupLinks,
            d => d.modifierGroupId === Number(o.split('|')[0].split('-')[1])
          ).sortOrder,
        200
      );
    }
  );
  const dataToSend = {
    // quantity: cartQuantity,
    quantity: 1,
    price: itemInfo.price,
    menuItemId: itemInfo.menuItemId,
    menuTypeId: itemInfo.menuTypeId,
    modifiers: sortedModifierData,
    menuItemName: (itemInfo?.menuItem || {})?.name,
    favorite: itemInfo?.menuItem?.favorite,
  };
  let cartItem = updateExcludeModifier([dataToSend]);
  cartItem = applyModFunction(cartItem);
  const modifierObject = getObjectValue(
    () =>
      mapStringCartToObject(
        cartItem,
        [],
        modifiersHashTable,
        modifierGroupsHashTable
      )[0].modifiers,
    []
  );
  const filteredModifiers = modifierObject?.filter((modifier, index, self) => {
    const hasModifiers = modifier?.modifiers && modifier?.modifiers.length > 0;
    const isUniqueModifierName =
      self.findIndex(item => item?.modifierName === modifier?.modifierName) ===
      index;

    return hasModifiers || isUniqueModifierName;
  });
  if (
    filteredModifiers.length > 0 &&
    filteredModifiers.filter(e =>
      menusList[menuIndex]?.globalModifierGroupIds?.includes(e.modifierGroupId)
    ).length > 0
  ) {
    arraymove(
      filteredModifiers,
      filteredModifiers.filter(
        e =>
          !menusList[menuIndex]?.globalModifierGroupIds?.includes(
            e.modifierGroupId
          )
      ),
      modifierObject.length - 1
    );
  }
  const updatedModifierObject = applyNoteFunction(filteredModifiers);
  dataToSend.modifierObject = updatedModifierObject;
  const modiferPrice = calculateModifierAmount(modifierData, params);
  const requestData = {
    ...dataToSend,
    // note, // later
    pending: true,
    price: Number(dataToSend.price) + modiferPrice,
    menuScreenId: Number(params.menuTypeId),
    ageRestricted: menusHashTable[Number(params.menuTypeId)].ageRestricted,
    internalId: new Date().getTime(),
    menuId: menusList[menuIndex].id,
    storeId: deviceInfo.storeId,
    modifiers: filteredModifiers,
    modifierData,
  };
  requestData.modifierJson = JSON.stringify(requestData);
  console.log({ requestData2: requestData });

  store.dispatch(setSelectedModifiers(requestData));
};

// on click of modifier items

const applyFunctionModifier = ({
  modifierDataToPush,
  nestedModifierArray,
  functionModifierId,
  modFunctionGroupId,
  modifierData,
  modifierInfo,
  isActive,
}) => {

  if (modifierInfo?.modifierGroupLinks?.length > 0 || !isActive) {
    store.dispatch(setFunctionModifierId(null));
    return;
  }

  let functionModifierPath;
  const nestedPath = nestedModifierArray.length > 0
    ? getPath(nestedModifierArray, modifierDataToPush)
    : null;

  if (
    nestedPath &&
    !modifierData.includes(`${nestedPath}|${functionModifierId}-${modFunctionGroupId}`)
  ) {
    functionModifierPath = `${nestedPath}|${functionModifierId}-${modFunctionGroupId}`;
  } else {
    functionModifierPath = `${modifierDataToPush}|${functionModifierId}-${modFunctionGroupId}`;
  }

  store.dispatch(pushModifierToItem(functionModifierPath));
  store.dispatch(setFunctionModifierId(null));
};

export const onClickModifierHelper = ({
  modifier,
  modifierGroup,
  isActive,
  key,
  nestedModifierArray,
  params,
}) => {

  const isKiosk = flowType() === 'kiosk';

  const { orders } = store.getState();

  const {
    modifierData,
    modifiersHashTable,
    modifierGroupsHashTable,
    functionModifierId,
    addModifierBool,
    menusList,
    menuIndex,
    globalSelectedModifierId
  } = orders;

  const modifierInfo = modifiersHashTable[modifier];
  const modifierGroupInfo = modifierGroupsHashTable[modifierGroup];

  // When the global modifier panel is active (opened from a cart item's GlobalMod button),
  // add this modifier as a child of selectedModifierPath instead of a top-level entry.
  if (globalSelectedModifierId) {
    handleModifierInGlobalModClick(modifierGroup, modifier);
    return;
  }

  store.dispatch(setSelectedModifierPath(''));

  const modifierDataToPush = `${modifier}-${modifierGroup}`;

  const modifierList = modifierInfo?.modifierGroupLinks?.map(item => ({
    ...item,
    ...modifierGroupsHashTable[item.modifierGroupId],
  }));

  if (
    modifierList?.length > 0 &&
    modifierList.some(x => Number(x.minimum) > 0)
  ) {
    store.dispatch(setSelectedModGroup({}));
  }

  if (
    (isKiosk ||
      key === 'edit' ||
      modifierList?.some(e => e.minimum > 0) ||
      modifierList?.some(e => e.flowRequired)) &&
    modifierInfo?.modifierGroupLinks?.length > 0 && !globalSelectedModifierId
  ) {

    store.dispatch(toggleNestedModifierFlag(true));
    store.dispatch(setIsSubNestModifier(true));

    nestedModifierArray.push(`${modifierDataToPush}`);

    store.dispatch(setNestedModifierArray(nestedModifierArray));
    store.dispatch(setTempModifier(modifierData));

    const preSelectModList = [];
    const activeMenuItemId = Number(urlSearchParams('menuId')) || 0;

    modifierInfo?.modifierGroupLinks?.forEach(item => {
      const group = modifierGroupsHashTable[item.modifierGroupId];

      if (
        group.hiddenMenuId === activeMenuItemId &&
        group.hiddenAutoAddModifierId
      ) {
        preSelectModList.push(
          `${modifierDataToPush}|${group.hiddenAutoAddModifierId}-${item.modifierGroupId}`
        );
      } else {
        group.modifierLinks.forEach(nMod => {
          if (nMod.included) {
            preSelectModList.push(
              `${modifierDataToPush}|${nMod.modifierId}-${group.id}`
            );
          }
        });
      }
    });

    if (
      modifierData.filter(d => d?.startsWith(modifierDataToPush)).length === 0
    ) {
      store.dispatch(appendModifiersToList(preSelectModList));
    }

    window.scrollTo(0, 0);

    store.dispatch(pushModifiersGroupData(modifierList, 'isNested'));
  }

  else if (nestedModifierArray.length === 0 && !addModifierBool) {

    if (modifierGroupInfo?.maximum === 1) {

      const modifiersToRemove = [];

      modifierGroupInfo?.modifierLinks?.forEach(d => {
        modifierData
          ?.filter(e => e)
          ?.forEach(modData => {
            if (
              modData?.startsWith(
                `${d.modifierId}-${modifierGroupInfo.id}`
              )
            ) {
              modifiersToRemove.push(modData);
            }
          });
      });

      if (modifiersToRemove.length > 0) {
        store.dispatch(removeModifiers(modifiersToRemove));
      }

      const wasToggleOff = modifiersToRemove.some(r =>
        r.startsWith(modifierDataToPush)
      );
      if (wasToggleOff) return;

    }

    store.dispatch(pushModifierToItem(modifierDataToPush));
  }

  else {

    let isWeightedVal = true;

    if (nestedModifierArray.length > 0) {

      const lastNested = nestedModifierArray[nestedModifierArray.length - 1];

      if (lastNested?.includes('|')) {

        const newEle = nestedModifierArray[0]?.split('|')[0];
        const newEle1 = newEle.split('-')[1];

        if (modifierGroupsHashTable[newEle1]?.isWeight === false) {
          isWeightedVal = false;
        }

      } else {

        const newEle1 = lastNested?.split('-')[1];

        if (modifierGroupsHashTable[newEle1]?.isWeight === false) {
          isWeightedVal = false;
        }

      }

    }

    if (isWeightedVal && addModifierBool) {

      store.dispatch(setTempModifier(modifierData));

      const modifiersToRemove = [];

      modifierGroupInfo?.modifierLinks?.forEach(d => {

        const path = getPath(
          nestedModifierArray,
          `${d.modifierId}-${modifierGroupInfo.id}`
        );

        if (modifierData?.includes(path)) {

          modifiersToRemove.push(path);
          modifiersToRemove.push(`${getPath(nestedModifierArray)}`);

        }

      });

      if (modifiersToRemove.length > 0) {
        modifiersToRemove.pop();
        store.dispatch(removeModifiers(modifiersToRemove));
      }

      let val = '';

      const lastNested = nestedModifierArray[nestedModifierArray.length - 1];

      if (lastNested?.includes('|')) {
        val = lastNested.split('|')[0];
        nestedModifierArray[nestedModifierArray.length - 1] = val;
      }

      if (nestedModifierArray.length > 1) {

        nestedModifierArray = [
          nestedModifierArray[nestedModifierArray.length - 1],
        ];

        store.dispatch(setNestedModifierArray(nestedModifierArray));
      }

      store.dispatch(pushModifierToCount(
        `${getPath(nestedModifierArray, `${modifierDataToPush}`)}`,
        true
      ));

      if (functionModifierId) {
        applyFunctionModifier({
          modifierDataToPush,
          nestedModifierArray,
          functionModifierId,
          modFunctionGroupId: menusList[menuIndex].modFunctionModifierGroupId,
          modifierData,
          modifierInfo,
          isActive,
        });
      }

      if (!isKiosk) {
        // onChangeModifier(getSyncModifierData(), params);
      }

      return;
    }

    else if (modifierGroupInfo?.maximum === 1) {

      const modifiersToRemove = [];

      modifierGroupInfo?.modifierLinks?.forEach(d => {

        const path = getPath(
          nestedModifierArray,
          `${d.modifierId}-${modifierGroupInfo.id}`
        );

        if (modifierData?.includes(path)) {
          modifiersToRemove.push(path);
          if (
            !nestedModifierArray.includes('|') &&
            modifierGroupsHashTable[nestedModifierArray[0]?.split('-')[1]]?.isWeight
          ) {
            modifiersToRemove.push(`${getPath(nestedModifierArray)}`);
          }
        }

      });

      if (modifiersToRemove.length > 0) {
        store.dispatch(removeModifiers(modifiersToRemove));
      }

      const clickedPath = `${getPath(nestedModifierArray, `${modifierDataToPush}`)}`;
      const wasToggleOff = modifiersToRemove.some(r => r === clickedPath);
      if (!wasToggleOff) {
        store.dispatch(pushModifierToItem(clickedPath));
      }

      store.dispatch(setAddModifierBool(false));
    }

    else {

      if (modifierGroupInfo?.maximum === 1) {

        const modifiersToRemove = [];

        modifierGroupInfo?.modifierLinks?.forEach(d => {

          const path = getPath(
            nestedModifierArray,
            `${d.modifierId}-${modifierGroupInfo.id}`
          );

          if (modifierData?.includes(path)) {
            modifiersToRemove.push(path);
            if (
              !nestedModifierArray.includes('|') &&
              modifierGroupsHashTable[nestedModifierArray[0]?.split('-')[1]]?.isWeight
            ) {
              modifiersToRemove.push(`${getPath(nestedModifierArray)}`);
            }
          }

        });

        if (modifiersToRemove.length > 0) {
          store.dispatch(removeModifiers(modifiersToRemove));
        }

      }

      store.dispatch(
        pushModifierToItem(
          `${getPath(nestedModifierArray, `${modifierDataToPush}`)}`
        )
      );

      store.dispatch(setAddModifierBool(false));

    }
  }

  if (functionModifierId) {
    applyFunctionModifier({
      modifierDataToPush,
      nestedModifierArray,
      functionModifierId,
      modFunctionGroupId: menusList[menuIndex].modFunctionModifierGroupId,
      modifierData,
      modifierInfo,
      isActive,
    });
  }

  if (!isKiosk) {
    // TODO: Check the behaviour here later as onChangeModifier is currently called in OrderItemModifierCart file in useEffect
    // onChangeModifier(getSyncModifierData(), params);
  }
};

export const onCountModifer = ({
  data,
  isInc,
  disable,
  count,
  selectedModArray,
  e,
}) => {
  const { orders } = store.getState();
  const {
    modifierData,
    modifiersHashTable,
    modifierGroupsHashTable,
    nestedModifierArray,
  } = orders;
  const modifierGroup = modifierGroupsHashTable[data.modifierGroupId];
  const modifier = modifiersHashTable[data.modifierId];
  const modifierLink = modifierGroup.modifierLinks.find(
    modLink => Number(modLink.modifierId) === Number(data.modifierId)
  );
  const max = modifierGroup.maximum;
  const remainingWeight = max - count;
  const isLimitOver = modifierGroup.isWeight && max > 1 && modifierLink?.weight > remainingWeight;
  const modifierCount = filter(
    modifierData,
    d =>
      d ===
      `${getPath(
        nestedModifierArray,
        `${data.modifierId}-${modifierGroup.id}`
      )}`
  ).length;
  const selectedModifierPath =
    modifier && modifierGroup
      ? `${modifierLink.modifierId}-${modifierGroup.id}`
      : '';
  let generatedPath = '';
  const { disableTemp, countTemp } = onModifierCountChange({
    isActive: !isInc,
    weight: data.weight,
    count,
    max,
    e,
  });
  let modArray = selectedModArray;
  if (isInc && !disable && !isLimitOver) {
    const resp = onClickModifierCounter(
      data.modifierId,
      modifierGroup.id,
      isInc,
      selectedModifierPath
    );
    isInc = resp.isInc;
    generatedPath = resp.generatedPath;
  } else if (!isInc) {
    const resp = onClickModifierCounter(
      data.modifierId,
      modifierGroup.id,
      isInc,
      selectedModifierPath
    );
    isInc = resp.isInc;
    generatedPath = resp.generatedPath;
    modArray = handleModArray(
      data,
      modifier,
      modifierCount,
      e,
      selectedModArray
    );
  }
  return {
    disable: disableTemp,
    countTemp,
    selectedModifierPath,
    generatedPath,
    modArray,
    isInc,
  };
};
const onModifierCountChange = ({ isActive, weight, e, count, max }) => {
  let disableTemp = false;
  let countTemp = count;
  if (e) {
    e.preventDefault();
  }
  const operator = weight && weight > 0 ? weight : 1;
  countTemp = isActive ? count - operator : count + operator;
  if (countTemp > max) {
    countTemp = countTemp - operator;
  }
  if (countTemp === max && max !== 0) {
    disableTemp = true;
  }
  return { disableTemp, countTemp };
};
const onClickModifierCounter = (
  modifier,
  modifierGroup,
  isInc,
  selectedModifierPath
) => {
  const modifierDataToPush = `${modifier}-${modifierGroup}`;
  const generatedPath = `${getPath(
    selectedModifierPath,
    `${modifierDataToPush}`
  )}`;
  return { isInc, generatedPath };
};
const handleModArray = (data, modifier, modifierCount, e, selectedModArray) => {
  if (e) e.preventDefault();
  let modArray = selectedModArray;
  if (modifierCount === 1) {
    const modifierIndex = selectedModArray.indexOf(data.name || modifier.name);
    modArray = modArray
      .slice(0, modifierIndex)
      .concat(modArray.slice(modifierIndex + 1, modArray.length));
  }
  return modArray;
};

export const onNestedBack = ({
  menuItemId,
  isDelete,
  updatedModifierData,
  isSave,
  nesMod,
}) => {
  const { orders } = store.getState();
  const {
    modifierData,
    modifierLevelData,
    nestedModifierArray,
    menuItemsHashTable,
    modifierGroupsHashTable,
    tempModifier,
    modifiersHashTable,
  } = orders;

  const activeMenuItemId = Number(urlSearchParams('menuId')) || 0;

  if (nesMod?.length > 0) {
    store.dispatch(pushModifierToItem(updatedModifierData));

    let newNestedArray = [...nesMod];
    newNestedArray.pop();

    store.dispatch(setNestedModifierArray(newNestedArray));

    if (newNestedArray.length === 0) {
      const modifierList = menuItemsHashTable[
        menuItemId
      ]?.modifierGroupLinks?.map(item => ({
        ...item,
        name: item.name,
        ...modifierGroupsHashTable[item.modifierGroupId],
      }));

      store.dispatch(pushModifiersGroupData(modifierList, 'isNested'));
      store.dispatch(toggleNestedModifierFlag(false));
    }

    return;
  }

  if (isSave) {
    const newArray = [];

    modifierData.forEach(modifier => {
      if (
        modifier?.startsWith(getPath(nestedModifierArray)) &&
        modifier.includes('|')
      ) {
        const val = modifier?.replace(getPath(nestedModifierArray), '');

        if (val) newArray.push(val);
      }
    });

    const requiredModifierList = [];

    modifierLevelData.forEach(item => {
      if (
        modifierGroupsHashTable[item.modifierGroupId].minimum > 0 &&
        modifierGroupsHashTable[item.modifierGroupId].hiddenMenuId !==
        activeMenuItemId
      ) {
        requiredModifierList.push({
          ...item,
          modifierGroupId: item.modifierGroupId,
          name: item.name,
          minimum: modifierGroupsHashTable[item.modifierGroupId].minimum,
        });
      }
    });

    const modifierListGroupById = groupBy(
      newArray,
      d => d.split('-')[1].split('|')[0]
    );

    for (let i = 0; i < requiredModifierList.length; i += 1) {
      if (
        (modifierListGroupById[requiredModifierList[i].modifierGroupId] || [])
          .length < requiredModifierList[i].minimum
      ) {
        store.dispatch(
          setNotification({
            type: 'danger',
            message: ERROR_MESSAGE.SELECT_REQUIRED_MODIFIERS,
          })
        );

        return;
      }
    }

    if (
      filter(
        filter([...modifierData], d => d?.startsWith(nestedModifierArray[0])),
        d => d.includes('|')
      ).length > 0 &&
      modifierData.includes(nestedModifierArray[0])
    ) {
      if (!modifierData.includes(nestedModifierArray[0])) {
        store.dispatch(pushModifierToItem(nestedModifierArray[0]));
      }
    } else if (
      modifierGroupsHashTable[nestedModifierArray[0].split('-')[1]].maximum ===
      1
    ) {
      const removeList = filter(tempModifier, d => {
        return (
          d.split('|')[0].split('-')[1] ===
          nestedModifierArray[0].split('-')[1] &&
          !d?.startsWith(nestedModifierArray[0])
        );
      });

      if (removeList.length > 0) {
        store.dispatch(removeModifiers(removeList));
      }
    }

    if (
      nestedModifierArray[1] &&
      modifierGroupsHashTable[nestedModifierArray[1].split('-').reverse()[0]]
        .maximum === 1
    ) {
      store.dispatch(
        removeModifiers(
          tempModifier.filter(
            d =>
              d.indexOf(
                `-${nestedModifierArray[1].split('-').reverse()[0]}`
              ) !== -1 &&
              d !== `${nestedModifierArray[0]}|${nestedModifierArray[1]}`
          )
        )
      );
    }

    if (
      nestedModifierArray[1] &&
      !modifierData.includes(nestedModifierArray[1]) &&
      modifierData.filter(d =>
        d?.startsWith(`${nestedModifierArray[0]}|${nestedModifierArray[1]}`)
      ).length === 0
    ) {
      store.dispatch(
        pushModifierToItem(
          `${nestedModifierArray[0]}|${nestedModifierArray[1]}`
        )
      );
    }

    if (
      nestedModifierArray[2] &&
      !modifierData.includes(nestedModifierArray[2]) &&
      modifierData.filter(d =>
        d?.startsWith(
          `${nestedModifierArray[0]}|${nestedModifierArray[1]}|${nestedModifierArray[2]}`
        )
      ).length === 0
    ) {
      store.dispatch(
        pushModifierToItem(
          `${nestedModifierArray[0]}|${nestedModifierArray[1]}|${nestedModifierArray[2]}`
        )
      );
    }

    if (!modifierData.includes(nestedModifierArray[0])) {
      store.dispatch(pushModifierToItem(nestedModifierArray[0]));
    }
  }

  if (isDelete) {
    store.dispatch(pushModifierToItem(updatedModifierData));
  }

  const newNestedArray = [...nestedModifierArray];
  newNestedArray.pop();

  store.dispatch(setNestedModifierArray(newNestedArray));

  if (newNestedArray.length === 0) {
    const modifierList = menuItemsHashTable[
      menuItemId
    ]?.modifierGroupLinks?.map(item => ({
      ...item,
      ...modifierGroupsHashTable[item.modifierGroupId],
    }));

    store.dispatch(pushModifiersGroupData(modifierList, 'isNested'));
    store.dispatch(toggleNestedModifierFlag(false));
  } else {
    const parentMenuItemId = newNestedArray[newNestedArray.length - 1]
      ?.split('|')
      ?.filter(el => el !== '')
      ?.slice(-1)[0]
      ?.split('-')[0];

    const modifierList = modifiersHashTable[
      parentMenuItemId
    ]?.modifierGroupLinks?.map(item => ({
      ...item,
      name: item.name,
      ...modifierGroupsHashTable[item.modifierGroupId],
    }));

    store.dispatch(pushModifiersGroupData(modifierList, 'isNested'));
  }
};

export const onRemoveItemFromCart = (internalId, navigate) => {
  const { orders } = store.getState();
  const { cart } = orders;
  const itemToDelete = cart.find(e => e.internalId === Number(internalId));
  if (!itemToDelete) return;

  const itemsToRemove = itemToDelete.uniqueIdForLinkedItem
    ? cart.filter(e => e.uniqueIdForLinkedItem === itemToDelete.uniqueIdForLinkedItem)
    : [itemToDelete];

  const pendingItems = itemsToRemove.filter(e => e.pending);
  const processedItems = itemsToRemove.filter(e => !e.pending);

  const navigateToOrders = () => navigate(`${APP_CONFIG.BASE_URL}/orders`);

  const removePendingThenNavigate = () => {
    if (pendingItems.length === 0) {
      navigateToOrders();
      return;
    }
    Promise.all(
      pendingItems.map(e => store.dispatch(removeItemFromCart(e.internalId)))
    ).then(navigateToOrders);
  };

  if (processedItems.length > 0) {
    const { orders, oauth } = store.getState();
    const { deviceInformation, authInfo, loggedInUserData } = oauth;
    const { seats } = orders;
    const datatosend = {
      storeId: deviceInformation.storeId,
      deviceId: deviceInformation.deviceId,
      employeeId: Number(loggedInUserData?.id) || Number(authInfo?.employeeId) || Number(authInfo?.id),
      employeeCard: loggedInUserData?.employeeCard,
      checkHeaderId: seats?.id,
      items: processedItems.map(e => ({ checkOrderItemId: e.id || e.checkItemId || e.checkOrderItemId })),
    };
    store
      .dispatch(deleteItm(datatosend))
      .then(res => {
        store.dispatch(setSeat({ ...res }));
        store.dispatch(updateChecksAfterResponse(res)).then(removePendingThenNavigate);
      })
      .catch(e => console.log(e));
  } else {
    removePendingThenNavigate();
  }
};

export const removeNestedModifier = (menuItemId) => {
  const { orders } = store.getState();

  const { modifierData, nestedModifierArray, modifierGroupsHashTable } = orders;

  const modifierDatatocheck = filter(
    modifierData,
    d => !d?.startsWith(getPath(nestedModifierArray))
  );

  if (modifierDatatocheck[0]?.includes('|')) {
    const newEle = modifierDatatocheck[0].split('|')[0];
    const newEle1 = newEle.split('-')[1];

    if (modifierGroupsHashTable[newEle1]?.isWeight === false) {
      const modifierDataToPush = filter(
        modifierData,
        d => !d?.startsWith(getPath(nestedModifierArray))
      );

      onNestedBack({
        menuItemId,
        isDelete: true,
        updatedModifierData: modifierDataToPush,
      });

      return;
    }
  } else if (modifierDatatocheck.length > 0) {
    const newEle1 = modifierDatatocheck[0]?.split('-')[1];

    if (modifierGroupsHashTable[newEle1]?.isWeight === false) {
      const modifierDataToPush = filter(
        modifierData,
        d => !d?.startsWith(getPath(nestedModifierArray))
      );

      onNestedBack({
        menuItemId,
        isDelete: true,
        updatedModifierData: modifierDataToPush,
      });

      return;
    }
  }

  let foundErr = false;
  let element = '';

  if (nestedModifierArray?.length > 1) {
    for (let index = 0; index < nestedModifierArray.length; index += 1) {
      element = nestedModifierArray[index];

      if (element.includes('|')) {
        const newEle = element.split('|')[0];
        const newEle1 = newEle.split('-')[1];

        if (modifierGroupsHashTable[newEle1]?.modifierLinks?.[0]?.weight > 0) {
          foundErr = true;
        }
      }
    }
  }

  if (foundErr) {
    const nestedFound = nestedModifierArray.filter(con => con === element);

    if (nestedFound.length > 0) {
      const nesModArray = [];
      nesModArray.push(nestedFound[0]);

      const modifierDataToPush = filter(
        modifierData,
        d => !d?.startsWith(getPath(nesModArray))
      );

      onNestedBack({
        menuItemId,
        isDelete: true,
        updatedModifierData: modifierDataToPush,
        nesMod: nesModArray,
      });

      return;
    }

    const modifierDataToPush = filter(
      modifierData,
      d => !d?.startsWith(getPath(nestedModifierArray))
    );

    onNestedBack({
      menuItemId,
      isDelete: true,
      updatedModifierData: modifierDataToPush,
    });

    return;
  }

  const modifierDataToPush = filter(
    modifierData,
    d => !d?.startsWith(getPath(nestedModifierArray))
  );

  onNestedBack({
    menuItemId,
    isDelete: true,
    updatedModifierData: modifierDataToPush,
  });
};

/** Used only when user selects a modifier from ModifierSearch modal (no linked modifiers). Same outcome as clicking that modifier in the main list: add once via pushModifierToItem only. */
export const handleModifierClickFromSearch = (data, setSearchModalOpen) => {
  const { orders } = store.getState();
  const {
    modifierGroupsHashTable,
    modifiersHashTable,
    modifierData,
    modifierLevelData,
    nestedModifierArray,
    functionModifierId,
    menusList,
    menuIndex,
  } = orders;

  const modifierGroupId = data.modifierGroupId;
  const modifierGroup = modifierGroupsHashTable[modifierGroupId];
  if (!modifierGroup) return;

  // If the modifier is out of stock, just close the modal and do nothing
  const modifierInfo = modifiersHashTable?.[data.modifierId];
  if (modifierInfo?.outOfStock) {
    setSearchModalOpen(false);
    return;
  }

  // Path must use modifierGroupId (hash table key) so cart/display lookup modifierGroupsHashTable[path.split('-')[1]] works
  const modifierDataToPush = `${data.modifierId}-${modifierGroupId}`;
  const modStoredValue = safeJsonParse(window.sessionStorage.getItem('globalMod'), {});

  const existingMod =
    modStoredValue?.modifierData?.length > 0 &&
    modStoredValue?.modifierData?.find((e) => e === modifierDataToPush);

  // Check if the modifier is already selected in the nested modifiers level
  const isExistingNestedMod = (modifierData || []).some((item) =>
    item.split('|').some((part) => part === modifierDataToPush)
  );

  const path = getPath(orders.selectedModifierPath || [], modifierDataToPush);
  const isActive = (modifierData || []).some(
    (mod) =>
      mod === path || mod?.startsWith(`${path}|`) || mod?.includes(path)
  );

  // when we need to check for weight logic in modifier
  if (modifierGroup?.isWeight) {
    let totalWeight = 0;
    // If modifier is already selected then we are adding the weight of the modifier to check the weight limit
    (modifierData || []).forEach((mod) => {
      const modId = mod.split('-')[0];
      const modWeight = modifierLevelData
        ?.find((e) => e.id === data.modifierGroupId)
        ?.modifierLinks?.find((e) => e.modifierId === Number(modId))?.weight;
      if (modWeight) {
        totalWeight += modWeight;
      }
    });

    // get the weight of the modifier which is being selected
    const modifierWeight = modifierLevelData
      ?.find((e) => e.id === data.modifierGroupId)
      ?.modifierLinks?.find((e) => e.modifierId === Number(data.modifierId))
      ?.weight;

    if (totalWeight >= modifierGroup.maximum) {
      store.dispatch(
        setErrorPopUp({
          res: 'You have selected the maximum number of modifiers for this group',
          noErrorTxt: true,
        })
      );
      return;
    }
    if (Number(totalWeight) + Number(modifierWeight) > modifierGroup.maximum) {
      store.dispatch(
        setErrorPopUp({
          res: 'You have selected the maximum number of modifiers for this group',
          noErrorTxt: true,
        })
      );
      return;
    }
  }

  // Count total selected modifiers in this group
  const totalGroupCount = (modifierData || []).filter((mod) => {
    if (!mod) return false;

    // check all nested / linked modifiers
    return mod.split('|').some((item) => {
      const groupId = item.split('-')[1];
      return String(groupId) === String(modifierGroupId);
    });
  }).length;

  // maximum === 0 means unlimited; otherwise must be under maximum
  const underLimit =
    modifierGroup.maximum === 0 || totalGroupCount < modifierGroup.maximum;

  // Build the correct nested path
  const linkedModifierGroups =
    modifiersHashTable?.[data.modifierId]?.modifierGroupLinks?.map((item) => ({
      ...item,
      ...modifierGroupsHashTable[item.modifierGroupId],
    })) || [];
  const hasLinkedModifiers = linkedModifierGroups.length > 0;

  let finalPath;
  if (nestedModifierArray.length > 0) {
    // Inside a nested modifier context — join the nested array + current modifier
    finalPath = [...nestedModifierArray, modifierDataToPush].join('|');
  } else if (hasLinkedModifiers) {
    // Has linked modifiers but nestedModifierArray is empty: use last modifierData entry as prefix
    const lastModifierDataPath = (modifierData || [])
      .filter(Boolean)
      .slice(-1)[0];
    finalPath = lastModifierDataPath
      ? `${lastModifierDataPath}|${modifierDataToPush}`
      : modifierDataToPush;
  } else {
    // No nested context and no linked modifiers — fall back to selectedModifierPath-based path
    finalPath = path;
  }

  // If maximum === 1 and already selected, just close the modal (no increment allowed)
  if (modifierGroup.maximum === 1 && isActive) {
    if (existingMod || isExistingNestedMod) {
      store.dispatch(
        setErrorPopUp({
          res: 'You have selected the maximum number of modifiers for this group',
          noErrorTxt: true,
        })
      );
    }
    return;
  }

  // If NOT under limit → show error popup, do not add
  if (!underLimit) {
    store.dispatch(
      setErrorPopUp({
        res: 'You have selected the maximum number of modifiers for this group',
        noErrorTxt: true,
      })
    );
    return;
  }

  // Under limit + same item already selected → increment quantity
  if ((existingMod || isExistingNestedMod) && isActive) {
    if (underLimit) {
      store.dispatch(
        pushModifierToCount(isExistingNestedMod ? finalPath : path, true)
      );
      // If at the limit, do nothing (just close modal)
      setSearchModalOpen(false);
    } else {
      store.dispatch(
        setErrorPopUp({
          res: 'You have selected the maximum number of modifiers for this group',
          noErrorTxt: true,
        })
      );
    }
    return;
  }

  // Under limit + new item → add normally
  store.dispatch(pushModifierToItem(finalPath));

  // If a modFunction is selected, attach it as a child modifier
  if (functionModifierId) {
    const modFunctionModifierGroupId =
      menusList?.[menuIndex]?.modFunctionModifierGroupId;
    if (modFunctionModifierGroupId) {
      const functionModifierPath = `${finalPath}|${functionModifierId}-${modFunctionModifierGroupId}`;
      if (!modifierData.includes(functionModifierPath)) {
        store.dispatch(pushModifierToItem(functionModifierPath));
      }
    }
    store.dispatch(setFunctionModifierId(null));
  }

  setSearchModalOpen(false);
};
